<template>
  <div class="icon-wait">
    <img class="icon-bg" src="./assets/question.svg" alt />
    <img src="./assets/magnifier.svg" class="magnifier" :class="{'animation':animation}" alt />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class IconWait extends Vue {
  @Prop({ type: Boolean, default: false }) animation!: false;
}
</script>

<style lang="scss" scoped>
@keyframes q-path {
  10% {
    transform: translate(-15px, 20px);
  }
  30% {
    transform: translate(-140px, 10px);
  }
  50% {
    transform: translate(-130px, -5px);
  }
  80% {
    transform: translate(-90px, -120px);
  }
  90% {
    transform: translate(-30px, -80px);
  }
  100% {
    transform: translate(0, 0);
  }
}
.icon-wait {
  position: relative;
  width: 446px;
  height: 353px;
  .icon-bg {
    width: 100%;
    height: 100%;
  }
  .magnifier {
    position: absolute;
    top: 220px;
    right: 110px;
    width: 98px;
    &.animation {
      animation: q-path 4s infinite;
    }
  }
}
</style>